module.exports = __webpack_public_path__ + "img/checkright.1a3186cc.png";